import { useContext, useEffect, useState } from 'react'
import '../../css/branded.css'
import '../../css/quilityIcons.css'
import { AgentContext } from '../../context/AgentContext'

const brandedButtonTypes = Object.freeze({
    PRIMARY: Symbol('PRIMARY'),
    SECONDARY: Symbol('SECONDARY'),
    TERTIARY: Symbol('TERTIARY'),
})

function BrandedButton({allowClickWhenDisabled = false , buttonLabel, clickHandler, mouseEnterHandler, mouseLeaveHandler, disabled = false, destructive = false, buttonType= brandedButtonTypes.PRIMARY, iconClassName = null, iconStyles = {width: 20, height: 20, position: 'relative'}, buttonStlyles = null, labelStyles = null, iconOnly=false, children}) {
    const handleClick = (e) => {
        if((disabled===false || allowClickWhenDisabled) && clickHandler !==undefined){
            clickHandler(e)
        }
    }

    const handleMouseEnter = (e) => {
        if(mouseEnterHandler !== undefined){
            mouseEnterHandler(e)
        }
    }

    const handleMouseLeave = (e) => {
        if(mouseLeaveHandler !== undefined){
            mouseLeaveHandler(e)
        }
    }

    const [type, setType] = useState('')

    useEffect(()=>{
        switch (buttonType) {
            case brandedButtonTypes.PRIMARY:
                setType('primary')
                break
            case brandedButtonTypes.SECONDARY:
                setType('secondary')
                break
            case brandedButtonTypes.TERTIARY:
                setType('tertiary')
                break
            default:
                setType('primary')
                break
        }
    }, [buttonType])

    const {isB2B} = useContext(AgentContext)

    return (
        <>
           <button className={`${isB2B ? 'b2b ' : ''}q-branded-${type}-button${destructive ? '-destructive' : ''}`} disabled={disabled && !allowClickWhenDisabled} onClick={handleClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{...buttonStlyles, outline: allowClickWhenDisabled ?  '2px var(--Colors-Gray-500) solid' : undefined}}>
                {iconClassName && (
                    <div className={`${iconClassName}`} style={{...iconStyles}}>{children}</div>
                )}
                {!iconClassName && children && (
                    <div style={{...iconStyles}}>{children}</div>
                )}
                {!iconOnly && (
                    <div style={{...labelStyles , cursor: allowClickWhenDisabled ? 'pointer' : undefined}} className={`${isB2B ? 'b2b ' : ''}q-branded-${type}-button-text${disabled ? '-disabled' : ''}${destructive && !disabled ? '-destructive' : ''}`}>{buttonLabel}</div>
                )}
            </button>
        </>
    )
}

export default BrandedButton;
export { brandedButtonTypes }